import { ref } from 'vue';

export const useEventToProp = () =>
{
  const prop = ref(null);

  const timestamp = ref(window.Date.now());

  const timestampUpdate = () =>
  {
    timestamp.value = window.Date.now();

    return timestamp.value;
  };

  const propUpdate = value =>
  {
    timestampUpdate();

    prop.value = value;

    return prop.value;
  };

  return { prop, propUpdate, timestamp, timestampUpdate };
};